import * as style from './index.css'
import * as preact from 'preact'
const { h } = preact

interface Props {
  children?: any;
}

export const Body = ({ children }: Props) => {
  return <div class={style.body__wrapper}>{children}</div>
}



// WEBPACK FOOTER //
// ./src/v1/components/Body/index.tsx